export const BASE_REM_NAME = "baseRem";

export const setBaseRem = (size) => {
  const html = document.getElementsByTagName("html")[0];
  html.style.fontSize = size;
  localStorage.setItem(BASE_REM_NAME, size);
};

export const getInitialRemFromLocalStorage = () => localStorage.getItem(BASE_REM_NAME);
